import { requestApi } from '@app/api';
import { withPayment } from '@app/api/paths';

type Transaction = {
  id: string;
  depositId: string;
  change: number;
  balance: number;
  content: 'PAY' | 'PUT_ADMIN' | 'PUT_VBANK' | 'WITHDRAW' | 'REFUNDED';
  description: string | null;
  timestamp: string;
};

export interface GetDepositTransactionResponse {
  count: number;
  transactions: Array<Transaction>;
}

/**
 * GET 특정 예치금 계좌의 거래내역
 */
export function getDepositTransactions({
  workspaceId,
  depositId,
  limit,
  offset,
}: {
  workspaceId: string;
  depositId: string;
  limit: number;
  offset: number;
}): Promise<GetDepositTransactionResponse> {
  return requestApi<GetDepositTransactionResponse>({
    url: withPayment(`/workspaces/${workspaceId}/deposit/${depositId}/transactions`),
    method: 'GET',
    credentials: true,
    params: { limit, offset },
  }).then((response) => response.data);
}
